<template>
    <rkm-layout-body title="Lista de solicitações">
        <template v-slot:actions>
            <rkm-button
                @click="$router.push({ name: 'manutencao-solicitacao-create' })"
                color="primary"
                authorize="store-manutencao-solicitacao"
            >
                Cadastrar solicitação
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
import List from '@/components/manutencao/solicitacao/List'

export default {
    components: { List },
}
</script>